import { Message, DomainMessagesTypes } from '../message';

export function isDocumentationMoved(message: Message): boolean {
  return message.type === DomainMessagesTypes.documentationMoved;
}
